import { Observable } from 'rxjs';
import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Una página del catálogo de terminales. Sin `merchantId` ⇒ todo el alcance del usuario. */
export interface TerminalCatalogQuery {
  /** UUID del comercio. Opcional: sin él el back responde con el alcance completo. */
  merchantId?: string;
  page: number;
  limit: number;
}

/**
 * Puerto de lectura del CATÁLOGO de terminales para el filtro "N° Terminal" de
 * Transacciones (feature 151). Es propio y chico (ISP): `TerminalRepository`
 * exige el comercio y lo consumen la pantalla Terminales y otros dos sitios, así
 * que volverlo opcional ahí cambiaría su contrato para quien no lo pide.
 */
export abstract class TerminalCatalogRepository {
  abstract getCatalogPage(query: TerminalCatalogQuery): Observable<TpvPage<TpvTerminal>>;
}
